import { AccountSyncComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-sync/account-sync.component";
import { AccountRegionsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-regions/account-regions.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { GlobalService } from "@bitwarden/common/services/global/global.service";
import { ToastOptions } from "@bitwarden/common/abstractions/platformUtils.service";
import { GuideSuccessToastComponent } from "@bitwarden/web-vault/app/components/guide-success-toast/guide-success-toast.component";
import { Institution } from "@bitwarden/web-vault/app/models/data/blobby/institution.data";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { createOtherInstitution } from "@bitwarden/web-vault/app/shared/utils/helper.institution/default-institution-account";
import {
  OTHER,
  DESKTOP_DIALOG,
  MOBILE_DIALOG,
  MOBILE_DIALOG_MIDDLE,
  RIGHT_PANEL_CONFIG,
} from "@bitwarden/web-vault/app/models/constants/global.constants";
import { RightPanelService } from "@bitwarden/web-vault/app/components/dialog/right-panel.service";
import {
  CurrencyType,
  DefaultSystemCurrency,
} from "@bitwarden/web-vault/app/models/types/location-currency.types";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { TransactionService } from "@bitwarden/web-vault/app/services/DataService/transaction/transaction.service";
import { AccountAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/accounts-add-edit/account-add-edit.component";
import { AccountBalanceComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-balance/account-balance.component";
import { Origin } from "@bitwarden/web-vault/app/models/types/general-types";
import { TransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction/transaction.component";
import { TableRow } from "@bitwarden/web-vault/app/components/tables/transaction-table/transaction-table";
import { effect, inject, TemplateRef } from "@angular/core";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { AddSymbolFormComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/symbol-form/add-symbol-form.component";
import { AddBudgetFormComponent } from "@bitwarden/web-vault/app/gloss/budget/budget-form/add-budget-form.component";
import { AutoBudgetPreviewDialogComponent } from "@bitwarden/web-vault/app/gloss/plugins/auto-budget/auto-budget-preview-dialog/auto-budget-preview-dialog.component";
import { SuggestedBudget } from "@bitwarden/web-vault/app/gloss/plugins/auto-budget/auto-budget.service";
import {
  DialogWrapperComponent,
  DialogWrapperData,
} from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { AppStateStoreService } from "@bitwarden/web-vault/app/services/store/app-state/app-state.store.service";
import {
  accountManualType,
  AccountManualType,
} from "@bitwarden/web-vault/app/models/types/account.types";
import { AccountTypeComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-type/account-type.component";
import { PluginConfigComponent } from "@bitwarden/web-vault/app/components/plugin-config/plugin-config.component";
import { CallToPremiumComponent } from "@bitwarden/web-vault/app/components/call-to-premium/call-to-premium.component";
import { ManuallyAddInstitutionComponent } from "@bitwarden/web-vault/app/components/manually-add-institution/manually-add-institution.component";

import { HelpBoxComponent } from "@bitwarden/web-vault/app/gloss/help-box/help-box.component";
import { PluginDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/plugins/plugin-details-dialog/plugin-details-dialog.component";
import {
  EditableTool,
  EditToolsDialogComponent,
} from "@bitwarden/web-vault/app/gloss/plugins/edit-tools-dialog/edit-tools-dialog.component";
import { PlanDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/plan-details-dialog/plan-details-dialog.component";
import { ChangePlanDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/change-plan-dialog/change-plan-dialog.component";
import { StatementBalanceDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/statement-balance-details/statement-balance-details.component";
import { ShareAccountComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/share-account/share-account.component";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";
import {
  StatementImportMappingComponent,
  StatementImportResult,
} from "@bitwarden/web-vault/app/gloss/cabinet/statement-import-mapping/statement-import-mapping.component";

import { DaliService } from "@bitwarden/web-vault/app/services/dali/dali.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { BudgetView } from "../../models/view/budget/budget.view";
import { ISymbolView } from "@bitwarden/web-vault/app/models/view/symbol/symbol.view";
import { IosRedemptionBoxComponent } from "@bitwarden/web-vault/app/gloss/ios-redemption-box/ios-redemption-box.component";
import { CouponDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/coupons/coupon-details-dialog/coupon-details-dialog.component";
import { CouponsComponent } from "@bitwarden/web-vault/app/gloss/coupons/coupon.component";
import { GuideComponent } from "@bitwarden/web-vault/app/gloss/help-guide/guide/guide.component";
import { PluginCardData } from "@bitwarden/web-vault/app/components/plugin-card/plugin-card.component";
import { CouponData } from "@bitwarden/web-vault/app/models/interfaces/coupons.interface";
import {
  closeScenDiffMessage,
  ScenarioDifferenceMessageComponent,
} from "@vault/web-vault/app/components/scenario-difference-message/scenario-difference-message.component";
import { take } from "rxjs";
import { BreakpointObserver } from "@angular/cdk/layout";
import { BOTTOM_SHEET_BREAKPOINT } from "@bitwarden/web-vault/app/shared/breakpoints";
import { BestScenarioDialogComponent } from "@vault/web-vault/app/gloss/wizard/best-scenario-dialog/best-scenario-dialog.component";
import { ScenarioStoreService } from "@vault/web-vault/app/services/store/scenario/scenario.store.service";
import type {
  MonthlySummaryDialogComponent,
  MonthlySummaryDialogData,
} from "@bitwarden/web-vault/app/gloss/monthly-summary/monthly-summary-dialog.component";
import type { MonthlyStats } from "@bitwarden/web-vault/app/services/monthly-summary/monthly-summary.service";
import { mobileSlideInConfig } from "@bitwarden/web-vault/app/components/dialog/mobile-slide-in-dialog";

/** Where the plugin-config dialog was opened from; decides what its Back button goes back to. */
export type PluginConfigOrigin = "account-flow" | "plugin-store" | "account-details";

export class DialogFactory {
  protected appState = inject(AppStateStoreService);
  private userStore: UserStoreService = inject(UserStoreService);
  private dialog: MatDialog = inject(MatDialog);
  private rightPanel = inject(RightPanelService);
  private globalService: GlobalService = inject(GlobalService);
  private deviceService = inject(DeviceDetectorService);
  private breakpointObserver = inject(BreakpointObserver);
  private transactionService = inject(TransactionService);
  protected scenarioStore: ScenarioStoreService = inject(ScenarioStoreService);
  isLoading = false;
  private readonly setCurStepAsComplete: () => Promise<void>;
  private closeDialog = () => this.dialogRef.close();

  // Track the origin context for plugin config flow
  private pluginConfigOrigin: PluginConfigOrigin | null = null;
  private currentPlugin: PluginCardData | null = null;
  private pluginFlowAccountType: AccountManualType = accountManualType.bank;

  // Embedded-picker account creation (e.g. statement import): skip the balance
  // step and report the created account back to the caller.
  private skipBalanceStep = false;
  private onAccountCreatedCb: ((account: AccountView) => void) | null = null;

  dialogRef: MatDialogRef<
    | AccountSyncComponent
    | AccountRegionsComponent
    | AccountAddEditComponent
    | AccountBalanceComponent
    | TransactionComponent
    | DialogWrapperComponent
    | AccountTypeComponent
    | CallToPremiumComponent
    | HelpBoxComponent
    | IosRedemptionBoxComponent
    | ScenarioDifferenceMessageComponent
    | PluginDetailsDialogComponent
    | PlanDetailsDialogComponent
    | CouponDetailsDialogComponent
    | GuideComponent
    | BestScenarioDialogComponent
    | MonthlySummaryDialogComponent
  >;
  inWizard: boolean = false;
  baseCurrency: CurrencyType;

  constructor(setCurStepAsComplete?: () => Promise<void>) {
    effect(() => {
      const preference = this.userStore.preferences.preferenceView();
      if (preference) {
        this.baseCurrency = preference.coreCurrency;
      } else {
        this.baseCurrency = DefaultSystemCurrency;
      }
    });

    effect(() => {
      this.inWizard = this.appState.wizard()?.isVisible ?? false;
    });

    this.setCurStepAsComplete = setCurStepAsComplete;
  }

  /** start account flow first ste
   *  this is called from manage-accounts.component -> addNew button
      if account type is bank or credit, open accountCreateMain
      if account type is stock or other, open creationOptions
   */
  /**
   * Run the manual account-creation flow for an embedded picker (e.g. the
   * statement-import mapping dialog): skip the post-create balance step and
   * invoke `onCreated` with the persisted account so the caller can select it.
   */
  createAccountForSelection(onCreated: (account: AccountView) => void) {
    this.skipBalanceStep = true;
    this.onAccountCreatedCb = onCreated;
    this.selectAccountManualTypeDialog();
  }

  selectAccountManualTypeDialog() {
    this.dialogRef?.close();
    this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "addNewAccount",
        showBackButton: false,
        useLargeRoundedCorners: true,
        component: AccountTypeComponent,
        onSelectAccountType: (type: AccountManualType) => this.onSelectAccountType(type),
      },
    });
  }

  selectAccountSyncDialog(accountType: AccountManualType = accountManualType.bank) {
    this.dialogRef?.close();
    this.dialogRef = this.rightPanel.open(AccountSyncComponent, {
      data: {
        accountType,
        createManually: () => this.createManualAccount(accountType),
        createByLinking: () => this.createLinkToBasiqAccount(false, accountType),
        backClicked: this.selectAccountManualTypeDialog.bind(this),
        closeDialog: this.closeDialog,
        isInWizard: this.inWizard,
      },
    });
  }

  onSelectAccountType(type: AccountManualType) {
    switch (type) {
      case accountManualType.stock:
      case accountManualType.other:
        this.createManualAccount(type);
        break;
      default:
        this.selectAccountSyncDialog(type);
        break;
    }
  }

  /** second step if CreationOptions
   *  2 options, manual or link to basiq
   *  this is skipped if account type is stock and default to manually (for now)
   */
  createManualAccount(accountType?: AccountManualType, isFromGuide: boolean = false) {
    this.dialogRef?.close();
    if (accountType === accountManualType.stock || accountType === accountManualType.other) {
      const countryCode = this.userStore.preferences.preferenceView()?.userLocation ?? "AU";
      const institution = createOtherInstitution(countryCode);
      this.addAccount(institution, accountType, isFromGuide);
    } else {
      this.selectInstitutionsDialog(accountType, isFromGuide);
    }
  }

  createLinkToBasiqAccount(
    isFromGuide: boolean = false,
    accountType: AccountManualType = accountManualType.bank,
  ) {
    this.dialogRef?.close();
    this.pluginConfigOrigin = "account-flow";
    this.pluginFlowAccountType = accountType;

    this.dialogRef = this.dialog.open(AccountRegionsComponent, {
      // isFromGuide reserves 30% width for the side tooltip panel, so it needs the wider dialog
      ...mobileSlideInConfig(isFromGuide ? DESKTOP_DIALOG : "account-regions-dialog"),
      data: {
        accountType,
        closeDialog: this.closeDialog,
        backClicked: () => this.selectAccountSyncDialog(accountType),
        setLoading: this.setLoading.bind(this),
        isFromGuide,
      },
    });
  }

  /** 3rd step
   *  all manual flows go through this.
   *  Institution selection now happens inside the account form, so this opens it directly
   *  (the separate institution-selection step was removed).
   */
  selectInstitutionsDialog(accountType?: AccountManualType, isFromGuide: boolean = false) {
    this.dialogRef?.close();
    this.addAccount(undefined, accountType, isFromGuide);
  }

  /** 4th step
   *  this is the last step of the manual flow
   *  when creating stock or other accounts, there are options to add balance and transactions
   *  those modals are opened inside the accountAddEditComponent
   */
  async addAccount(
    selectedInstitution?: Institution | InstitutionView,
    accountType?: AccountManualType,
    isFromGuide: boolean = false,
  ) {
    this.dialogRef = this.rightPanel.open(AccountAddEditComponent, {
      data: {
        isFromGuide: isFromGuide,
        actionSucceeded: () => this.openTransactionImportModal(isFromGuide),
        institution: selectedInstitution,
        accountCurrency: this.baseCurrency,
        backClicked: () => {
          if (accountType === accountManualType.stock || accountType === accountManualType.other) {
            this.selectAccountManualTypeDialog();
          } else {
            this.selectAccountSyncDialog(accountType);
          }
        },
        isWizard: this.inWizard,
        accountType: accountType,
        closeDialog: this.closeAccountAddModal.bind(this),
        skipBalance: this.skipBalanceStep,
        onAccountCreated: this.onAccountCreatedCb,
      },
    });
  }
  /** end of manual flow */

  /** 2nd step related functions
   */
  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  /** 4th step(addAccount) related functions
   */
  openTransactionImportModal(isFromGuide: boolean = false) {
    const actionKey = isFromGuide ? "accountCreatedSuccessfully" : "createdSuccessfully";
    const options: ToastOptions | undefined = isFromGuide
      ? { extraClass: "toast-guide-success", toastComponent: GuideSuccessToastComponent }
      : undefined;
    this.actionSucceeded(actionKey, options).then();
    this.dialogRef.close();
  }

  async closeAccountAddModal(isBack: boolean) {
    if (!isBack && this.inWizard && this.setCurStepAsComplete) {
      await this.setCurStepAsComplete();
    }
    this.dialogRef.close();
    this.skipBalanceStep = false;
    this.onAccountCreatedCb = null;
  }
  /** end 4th step(addAccount) related functions
   */

  /** called by account-details-table and stepper */
  async addBalanceSelected(account: AccountView) {
    const firstManuelAccount = account;
    if (firstManuelAccount) {
      this.addBalance(firstManuelAccount);
      return true;
    } else {
      this.globalService.showMessage(
        "info",
        "addAccount",
        "pleaseCreateAnAccountManuallyToAddBalance",
      );
      return false;
    }
  }

  addBalance(
    account: AccountView,
    onActionSucceeded: CallableFunction = this.closeDialog,
    isFromGuide: boolean = false,
    initialBalance?: number,
    initialDate?: string,
    initialCurrency?: string,
    initialDescription?: string,
    initialType?: string,
  ) {
    if (account.origin !== Origin.manual) {
      this.globalService.showWarningMessage("warning", "balanceForManualAccount");
      return;
    }

    // Falls back to the account's own most-recently-transacted symbol (stock/other accounts
    // only — undefined for bank/credit) so callers that don't have a specific symbol in hand
    // still open Add Balance pre-filled consistently with Add Transaction. Only used when that
    // symbol is still a selectable currency option — otherwise a symbol since deleted from the
    // system would get silently pre-filled into a field that can no longer offer it. Only
    // computed when the caller didn't already supply a symbol.
    const resolvedInitialCurrency = initialCurrency ?? this.getFallbackBalanceSymbol(account);

    this.dialogRef = this.rightPanel.open(AccountBalanceComponent, {
      data: {
        accountView: account,
        actionSucceeded: onActionSucceeded,
        closeDialog: this.closeBalanceModal.bind(this),
        initialBalance,
        initialDate,
        initialCurrency: resolvedInitialCurrency,
        initialDescription,
        initialType,
        isFromGuide,
      },
    });
  }

  private getFallbackBalanceSymbol(account: AccountView): string | undefined {
    const accountSymbolCode = this.transactionService.getMostRecentSymbolForAccount(account);
    return accountSymbolCode &&
      this.transactionService.getSelectableBalanceSymbols().includes(accountSymbolCode)
      ? accountSymbolCode
      : undefined;
  }

  async actionSucceeded(actionKey: string, options?: ToastOptions) {
    this.globalService.showSuccessMessage("succeeded", actionKey, options);
  }

  async closeBalanceModal() {
    this.dialogRef.close();
    // if (this.inWizard && this.setCurStepAsComplete) {
    //   await this.setCurStepAsComplete();
    // }
  }

  /** called by account-add-edit and account-details */
  addTransaction(
    account: AccountView,
    onActionSucceeded: CallableFunction = this.closeDialog,
    isFromGuide = false,
  ) {
    this.dialogRef = this.rightPanel.open(TransactionComponent, {
      data: {
        isFromGuide,
        accountView: account,
        actionSucceeded: onActionSucceeded,
        closeDialog: this.closeDialog,
      },
    });
  }

  /** called by edit-transaction and manage-symbols*/
  addSymbol(onSymbolCreated?: (symbol: ISymbolView) => void) {
    this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "addSymbol",
        showBackButton: false,
        component: AddSymbolFormComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          onSymbolCreated,
        },
      },
    });
  }

  /** called by add-budget*/
  addBudget(onBudgetSaved?: (budget: BudgetView) => void) {
    this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "createANewBudget",
        showBackButton: false,
        component: AddBudgetFormComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          onBudgetSaved,
        },
      },
    });
  }

  /** Review dialog for auto-generated budget suggestions; `onConfirm` receives the finalized rows. */
  openAutoBudgetPreview(
    suggestions: SuggestedBudget[],
    onConfirm: (
      finalized: SuggestedBudget[],
      markCreated: (created: SuggestedBudget) => void,
    ) => void | Promise<void>,
  ) {
    // Click-away/Escape must not close the panel while budgets are being written.
    let isWriting = false;
    this.dialogRef = this.rightPanel.open(
      DialogWrapperComponent,
      {
        data: {
          title: "reviewAutoBudget",
          showBackButton: false,
          component: AutoBudgetPreviewDialogComponent,
          componentInputs: {
            closeDialog: this.closeDialog,
            onBusyChange: (busy: boolean) => (isWriting = busy),
            suggestions,
            onConfirm,
          },
        },
      },
      { isBusy: () => isWriting },
    );
  }

  editBudget(budget: BudgetView) {
    return (this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "editBudget",
        showBackButton: false,
        component: AddBudgetFormComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          budget,
        },
      },
    }));
  }

  callHelpBox(slideFromRight = false) {
    // Capture the ref so a late close can't hit a different dialog opened via this factory.
    const ref = (this.dialogRef = this.dialog.open(HelpBoxComponent, {
      ...(slideFromRight ? RIGHT_PANEL_CONFIG : { maxWidth: "100vw", maxHeight: "100vh" }),
      data: {
        dialogOpen: true,
        closeDialog: () => ref.close(),
      },
      disableClose: false,
    }));
  }

  manuallyAddInstitution(save: CallableFunction, footerTemplate: TemplateRef<any>) {
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      width: "400px",
      data: {
        title: "manuallyAddInstitution",
        showBackButton: false,
        component: ManuallyAddInstitutionComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
        },
        footerTemplate,
      },
      disableClose: true,
    });
  }

  /**
   * Column-mapping dialog for importing a tabular bank statement (csv/xls/xlsx).
   * `onConfirm` receives the resolved account + built transactions when the user
   * finishes the map -> review flow. Reusable anywhere a statement is uploaded.
   */
  openStatementImportMapping(
    file: File,
    onConfirm: (result: StatementImportResult) => void,
    onAccountCreated?: (account: AccountView) => void,
  ) {
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...mobileSlideInConfig(DESKTOP_DIALOG),
      disableClose: true,
      data: {
        title: "importTransactionsFromStatement",
        showBackButton: false,
        component: StatementImportMappingComponent,
        componentInputs: {
          file,
          onConfirm,
          onAccountCreated,
          closeDialog: this.closeDialog,
        },
      },
    });
    return this.dialogRef;
  }

  /**
   * Opens the "Share {account}" slide-out — lets the user pick one or more teams to share the
   * account into. `onShare` receives the selected collection ids; the caller does the actual
   * fork/share network calls (see manage-accounts.component's shareAccountToOrgs), this just
   * closes the dialog once that's kicked off — outcome is reported back via toast.
   *
   * The confirm button lives in the caller's own `footerTemplate` (right-panel dialogs force
   * `.modal-body` to `height: auto`, so a button inside ShareAccountComponent can't stick to the
   * bottom — only DialogWrapperComponent's dedicated footer slot, a sibling of `.modal-body`,
   * actually sits at the panel's bottom). `onButtonOptionsChange` hands that template ShareAccount
   * Component's live ActionButton (its onClick closure still reads that component's own state).
   */
  shareAccount(
    account: AccountView,
    onShare: (collectionIds: string[]) => void,
    onButtonOptionsChange: (options: ActionButton) => void,
    footerTemplate: TemplateRef<any>,
  ) {
    this.dialogRef?.close();
    this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      // Desktop keeps the standard right-panel slide (RIGHT_PANEL_CONFIG.panelClass); this extra
      // class only changes anything under the material-ui.scss 768px breakpoint, where it turns
      // the panel into a bottom sheet per the GLOSS DS 2.1 mobile share design.
      panelClass: [RIGHT_PANEL_CONFIG.panelClass, "share-account-bottom-sheet"],
      // RIGHT_PANEL_CONFIG's height "100vh" makes CDK's GlobalPositionStrategy treat the pane as
      // flush-vertical and force `align-items: flex-start` on the overlay wrapper, which would
      // defeat the bottom positioning below. Desktop height still comes from the CSS
      // (.right-panel-dialog { height: 100vh !important }), and top:"0" is flex-start anyway.
      height: "",
      data: {
        title: "shareAccountTitle",
        titleParam: account.displayName,
        showBackButton: false,
        footerTemplate,
        component: ShareAccountComponent,
        componentInputs: {
          onShare: (collectionIds: string[]) => {
            onShare(collectionIds);
            this.closeDialog();
          },
          onButtonOptionsChange,
        },
      },
    });

    // Browsers without :has() can't use the material-ui.scss alignment rule, so the bottom-sheet
    // position is applied from JS as well (pin to the bottom there or the "sheet" would sit at
    // the top-right). It runs everywhere, which is harmless: where :has() works, the CSS
    // !important alignment wins over these inline styles. Observed rather than read once so a
    // resize/rotation after opening keeps the position in step with the CSS breakpoint.
    const shareDialogRef = this.dialogRef;
    const positionSub = this.breakpointObserver
      .observe(BOTTOM_SHEET_BREAKPOINT)
      .subscribe(({ matches }) =>
        shareDialogRef.updatePosition(matches ? { bottom: "0" } : RIGHT_PANEL_CONFIG.position),
      );
    shareDialogRef.afterClosed().subscribe(() => positionSub.unsubscribe());
  }

  statementBalanceDetails(rowData: TableRow, parentDialogRef?: MatDialogRef<any>) {
    this.dialogRef?.close();
    this.dialogRef = this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "statementBalanceDetails",
        showBackButton: false,
        component: StatementBalanceDetailsComponent,
        componentInputs: { rowData, parentDialogRef },
      },
    });
  }

  openPluginDetailsDialog(
    plugin: PluginCardData,
    isInstalled: boolean = false,
    onInstallSuccess?: CallableFunction,
    autoOpenForm: boolean = false,
  ) {
    this.dialogRef?.close();
    this.currentPlugin = plugin;
    this.pluginConfigOrigin = "plugin-store";

    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      data: {
        title: "myPlugin",
        // The plugin's own name leads the panel (Manage when installed, details otherwise).
        rawTitle: plugin.title,
        showBackButton: false,
        component: PluginDetailsDialogComponent,
        componentInputs: {
          plugin: plugin,
          isInstalled: isInstalled,
          closeDialog: this.closeDialog,
          onInstallSuccess: onInstallSuccess,
          parentDialogFactory: this,
          autoOpenForm: autoOpenForm,
        },
      },
    });
  }

  openPlanDetailsDialog(config: {
    title?: string;
    planType?: "annual" | "monthly";
    marketLabel?: string;
    showSwitchButton?: boolean;
    showSubscribeButton?: boolean;
    onAnnualAction?: ((withCard?: boolean) => void) | (() => void);
    onMonthlyAction?: ((withCard?: boolean) => void) | (() => void);
    onCancelSubscription?: () => void;
    initialPaymentMethod?: "add" | "skip";
  }) {
    const title = config.title || "bundleDetails";

    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...mobileSlideInConfig(DESKTOP_DIALOG),
      width: "600px",
      data: {
        title: title,
        showBackButton: false,
        component: PlanDetailsDialogComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          planType: config.planType,
          marketLabel: config.marketLabel || "",
          showSwitchButton: config.showSwitchButton || false,
          showSubscribeButton: config.showSubscribeButton || false,
          onAnnualAction: config.onAnnualAction,
          onMonthlyAction: config.onMonthlyAction,
          onCancelSubscription: config.onCancelSubscription,
          initialPaymentMethod: config.initialPaymentMethod,
        },
      },
      disableClose: false,
    });
  }

  openChangePlanDialog(config: {
    newPlanType: "annual" | "monthly";
    selectedPaymentMethod: "add" | "skip";
    marketLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
  }) {
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...mobileSlideInConfig(DESKTOP_DIALOG),
      width: "600px",
      data: {
        title: "changePlan",
        showBackButton: false,
        component: ChangePlanDialogComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          newPlanType: config.newPlanType,
          selectedPaymentMethod: config.selectedPaymentMethod,
          marketLabel: config.marketLabel,
          onConfirm: config.onConfirm,
          onCancel: config.onCancel,
        },
      },
      disableClose: false,
    });
  }

  openIosRedemptionFlow(offerCode: string) {
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      panelClass: "no-background-dialog",
      disableClose: true,
      data: {
        title: "iosOfferCodeRedemption",
        showBackButton: false,
        component: IosRedemptionBoxComponent,
        componentInputs: { offerCode },
      },
    });
  }

  /**
   * `overCurrentDialog` (from the "browse all coupons" slide-out): open on top of the current
   * dialog instead of replacing it, so closing the details goes back to the coupon list.
   */
  openCouponDetailsDialog(coupon: CouponData, overCurrentDialog = false) {
    if (!overCurrentDialog) {
      this.dialogRef?.close();
    }
    const ref = this.dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      data: {
        title: "discountDetails", // Ensure this key exists in your i18n
        showBackButton: false,
        useLargeRoundedCorners: true,
        plainCloseButton: true,
        component: CouponDetailsDialogComponent,
        componentInputs: {
          coupon: coupon,
          closeDialog: () => ref.close(),
        },
      },
      disableClose: false,
    });
    if (!overCurrentDialog) {
      this.dialogRef = ref;
    }
  }

  openBrowseAllCouponsDialog() {
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      data: {
        title: "browseAllCoupons",
        showBackButton: false,
        component: CouponsComponent,
        componentInputs: { limit: undefined, parentDialogFactory: this },
      },
      disableClose: false,
    });
  }

  /**
   * `origin` sets where Back goes for this dialog, overriding `pluginConfigOrigin`. That field is
   * per instance and only set by the add-account and plugin-store flows, so a caller with its own
   * `new DialogFactory()` (account-details) must pass it, or Back opens the add-account flow (#5451).
   * `accountId` (account-details' Fetch data): plugin-config syncs only that account (#5450).
   * `accountType` is the add-account flow Back returns to whenever Back goes there: the origin is
   * "account-flow" or unset (a fresh factory like account-regions' never sets `pluginConfigOrigin`).
   * Same per-instance blind spot as `origin`: `pluginFlowAccountType` defaults to bank unless
   * createLinkToBasiqAccount ran on this very instance (#6004).
   */
  openPluginConfigDialog(
    pluginId: string,
    options?: {
      syncOnly?: boolean;
      forceReauth?: boolean;
      origin?: PluginConfigOrigin;
      accountId?: string;
      accountType?: AccountManualType;
    },
  ) {
    this.dialogRef?.close();

    const origin = options?.origin ?? this.pluginConfigOrigin;
    const backHandler =
      origin === "account-details"
        ? // Opened over the account the user is looking at: Back just closes the dialog.
          () => this.dialogRef?.close()
        : origin === "plugin-store"
          ? () => this.reopenPluginDetails()
          : () =>
              this.createLinkToBasiqAccount(
                false,
                options?.accountType ?? this.pluginFlowAccountType,
              );

    this.dialogRef = this.dialog.open<DialogWrapperComponent, DialogWrapperData>(
      DialogWrapperComponent,
      {
        ...RIGHT_PANEL_CONFIG,
        autoFocus: false,
        data: {
          onBackClicked: backHandler,
          title: "Configure Plugin",
          component: PluginConfigComponent,
          componentInputs: {
            pluginId: pluginId,
            syncOnly: options?.syncOnly ?? false,
            forceReauth: options?.forceReauth ?? false,
            accountId: options?.accountId,
          },
          showBackButton: true,
        },
      },
    );
  }

  /**
   * Reopen the plugin details dialog when coming back from plugin config
   */
  private reopenPluginDetails() {
    if (this.currentPlugin) {
      const isInstalled = this.userStore.plugin
        .collection()
        ?.some((p) => p.name === this.currentPlugin.id);
      this.openPluginDetailsDialog(this.currentPlugin, isInstalled);
    } else {
      // Fallback: just close if we don't have plugin info
      this.dialogRef?.close();
    }
  }

  /** "Edit your tools" right panel: pin up to 4 tools; changes apply immediately. */
  openEditToolsDialog(tools: EditableTool[]): void {
    this.dialogRef?.close();
    // Phone (Tailwind `sm`): the panel is a full page, so it leads with a back arrow like the
    // DS 2.1 mobile "Edit your tools"; on desktop it is a side panel with a close button.
    const isPhone =
      typeof window !== "undefined" && !!window.matchMedia?.("(max-width: 639px)").matches;
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      data: {
        title: "pluginsEditYourTools",
        showBackButton: isPhone,
        showCloseButton: !isPhone,
        onBackClicked: () => this.dialogRef?.close(),
        customizedCloseIcon: "close",
        component: EditToolsDialogComponent,
        componentInputs: { tools },
      },
    });
  }

  async openWealthComparisonDialog(): Promise<void> {
    // Dynamic import breaks a require cycle: this file is reachable from
    // CalculationBaseStoreService's own dependency chain (via guide-wizard.service ->
    // wizards.store.collection -> user.store.service -> filter.control), and
    // WealthComparisonDialogComponent depends on CalculationTodayStoreService, which extends
    // CalculationBaseStoreService. A static import here closes that loop and throws
    // "Class extends value undefined" when calculation-base.store.service.ts is still
    // mid-evaluation. Deferring the import until the dialog actually opens avoids it.
    const { WealthComparisonDialogComponent } = await import(
      "@bitwarden/web-vault/app/gloss/plugins/wealth-comparison/wealth-comparison-dialog.component"
    );
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...mobileSlideInConfig(DESKTOP_DIALOG),
      width: "520px",
      // Bounds the dialog so DialogWrapperComponent's tw-h-full/tw-overflow-y-auto content area
      // can actually scroll — without a definite height that flex/overflow trick is inert and
      // content taller than the viewport gets silently clipped instead.
      maxHeight: "85vh",
      data: {
        title: "wealthSnapshot",
        showBackButton: false,
        component: WealthComparisonDialogComponent,
        componentInputs: {},
      },
      disableClose: true,
    });
  }

  openGuideDialog(isPremiumUser: boolean = false) {
    this.dialogRef?.close();
    this.dialogRef = this.dialog.open(DialogWrapperComponent, {
      ...RIGHT_PANEL_CONFIG,
      data: {
        title: "guide",
        showBackButton: false,
        customizedCloseIcon: "close",
        component: GuideComponent,
        componentInputs: {
          closeDialog: this.closeDialog,
          isPremiumUser: isPremiumUser,
        },
      },
    });
  }

  // scenario difference message (based on wizard balance)
  openScenarioDifferenceMessage() {
    const scenarioCollection = this.scenarioStore.interestScenario.collection();
    if (!scenarioCollection) {
      this.globalService.showInfoMessage("info", "scenarioNotReady");
      return;
    }
    const dialogRef = this.dialog.open(ScenarioDifferenceMessageComponent, {
      data: {
        scenarioData: scenarioCollection,
        coreCurrency: this.userStore.preferences.preferenceView().coreCurrency,
      },
      disableClose: true,
      panelClass: ["scenario-difference-dialog"],
      autoFocus: false,
    });
    dialogRef
      .afterOpened()
      .pipe(take(1))
      .subscribe(() => {
        const matDialogContainer = document.querySelector("mat-dialog-container");
        if (matDialogContainer) {
          matDialogContainer.classList.add(
            this.deviceService.isMobile()
              ? "mobile-mat-dialog-container"
              : "desktop-mat-dialog-container",
          );
        }
      });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result === closeScenDiffMessage.continue) {
          this.openBestScenarioDialog();
        } else {
          return;
        }
      });
  }

  openBestScenarioDialog() {
    this.dialogRef = this.dialog.open(BestScenarioDialogComponent, {
      maxWidth: "800px",
      data: {
        closeDialog: () => this.closeScenarioDialog(),
      },
      disableClose: true,
      panelClass: ["tw-py-4", "tw-w-[500px]", "tw-h-[600px]", "xs:tw-w-[90%]", "xs:tw-h-[90%]"],
      autoFocus: false,
    });
  }

  closeScenarioDialog() {
    this.dialogRef?.close();
  }

  // initialStats: pre-fetched stats for `month`, if the caller already computed them (e.g. the
  // auto-open activity-gate check in views.component.ts) — lets the dialog skip redundantly
  // re-fetching + recomputing the same month's stats immediately after opening.
  async openMonthlySummary(
    month: Date,
    initialStats?: MonthlyStats,
  ): Promise<MatDialogRef<MonthlySummaryDialogComponent>> {
    const { MonthlySummaryDialogComponent } = await import(
      "@bitwarden/web-vault/app/gloss/monthly-summary/monthly-summary-dialog.component"
    );
    return this.dialog.open<MonthlySummaryDialogComponent, MonthlySummaryDialogData>(
      MonthlySummaryDialogComponent,
      {
        panelClass: ["monthly-summary-dialog", "no-background-dialog"],
        maxWidth: "960px",
        width: "95vw",
        data: { month, initialStats },
        disableClose: false,
        autoFocus: false,
      },
    );
  }
}
